import { gsap, Power3 } from "gsap";

export default class Expanders {
    constructor() {
        this.expanders = document.querySelectorAll('.js-expand-trigger');
    
        if(this.expanders){
            this.init();
        }
    }

    init() {

        this.expanders.forEach(element => {
            element.addEventListener("click", (e) => {
                this.expand(element);
            });
            element.addEventListener("keydown", (e) => {
                if (e.code === "Enter") {
                    this.expand(element);
                }
            });
        });

    }
    expand(element) {
        if(!element.classList.contains('js-expand-trigger-active')){
            element.classList.add('js-expand-trigger-active');
            gsap.to(element.nextElementSibling, {
                duration: .25,
                delay: .25,
                height: 'auto',
                ease: Power3.in
            });
        } else {
            element.classList.remove('js-expand-trigger-active');
            gsap.to(element.nextElementSibling, {
                duration: .25,
                delay: .25,
                height: 0,
                ease: Power3.in
            });
        }
    }
    
}
